module.exports = __webpack_public_path__ + "img/details2.30521a4c.png";